import React from 'react';
import { Md3DRotation} from "react-icons/md";
import Helper from '../../utils/helper';

export default class ElementItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            show3d: false
        };
        this.isShow3dOnDemand = Helper.isShow3dOnDemand();
    }

    on3dClick = () => {
        this.setState({
            show3d: true
        });
    }

    render() {
        const { t, element } = this.props;
        //const editorSrc = `${window.location.protocol}//editor.${window.location.host}?productId=${project.id}&nocontrols=true`;        
        const editorSrc = `/viewer3d?src=${element.modelUrl}`;
        return (
            <div className="goodsItem" onClick={this.props.onClick}>
                <div className="goodsItem3d">
                    <img style={{ width: '100%' }}
                        src={element.iconUrl} />
                    {/*(this.isShow3dOnDemand && !this.state.show3d) ?
                        <>
                            <img style={{ width: '100%' }}
                                src={element.iconUrl} />
                            <Md3DRotation className="icon-3d" onClick={this.on3dClick} />
                        </>
                        :
                        <iframe
                            width="100%"
                            height="100%"
                            src={editorSrc}
                            frameBorder="0"
                        />
                    */}
                </div>
                <div className="align-center element-label">{element.categoryName}</div>
            </div>
        );
    }
}